import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import Logo from '../common/Logo';
import { appUrl } from '../../utils/routing';

const links = [
  ['Modelos', '/modelos-laudo'],
  ['Referências', '/referencias-laudos'],
  ['Como funciona', '/#como-funciona'],
  ['Planos', '/#planos'],
];

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`sticky top-0 z-50 w-full max-w-full overflow-x-hidden transition-colors ${scrolled ? 'bg-paper/95 backdrop-blur-md border-b border-line' : 'bg-paper border-b border-transparent'}`}>
      <div className="mx-auto w-full max-w-7xl min-w-0 px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 min-w-0 items-center justify-between sm:h-20">
          <div className="flex min-w-0 items-center"><Link to="/" className="flex min-w-0 items-center group" aria-label="Laudando Online, página inicial"><Logo markClassName="h-9 w-9 sm:h-10 sm:w-10" /></Link></div>
          <div className="hidden md:flex items-center gap-8">
            {links.map(([label, href]) => href.startsWith('/#') ? <a key={label} href={href} className="text-sm font-semibold text-muted hover:text-navy transition-colors">{label}</a> : <Link key={label} to={href} className="text-sm font-semibold text-muted hover:text-navy transition-colors">{label}</Link>)}
          </div>
          <div className="hidden md:flex items-center gap-3">
            {user ? (
              <a href={appUrl('/painel')} className="btn-primary">Dashboard</a>
            ) : (
              <><a href={appUrl('/login')} className="btn-secondary border-transparent">Entrar</a><a href={appUrl('/login')} className="btn-convert">Criar meu primeiro laudo</a></>
            )}
          </div>
          <div className="md:hidden flex shrink-0 items-center"><button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="flex min-h-[44px] min-w-[44px] items-center justify-center p-2 text-muted" aria-label={isMobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}>{isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}</button></div>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className="md:hidden w-full max-w-full overflow-x-hidden bg-paper border-t border-line p-5 space-y-4 shadow-card sm:p-6">
          {links.map(([label, href]) => href.startsWith('/#') ? <a key={label} href={href} onClick={() => setIsMobileMenuOpen(false)} className="block py-2 text-base font-semibold text-ink">{label}</a> : <Link key={label} to={href} onClick={() => setIsMobileMenuOpen(false)} className="block py-2 text-base font-semibold text-ink">{label}</Link>)}
          <div className="pt-4 border-t border-line flex flex-col gap-3">
            {user ? <a href={appUrl('/painel')} className="btn-primary w-full">Dashboard</a> : <><a href={appUrl('/login')} className="btn-secondary w-full">Entrar</a><a href={appUrl('/login')} className="btn-convert w-full">Criar meu primeiro laudo</a></>}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
